import { useTranslation } from "react-i18next";
import { usePromoCode } from "@/hooks/use-promo-code";
import { stats } from "@/content/stats";

const Intro = () => {
  const { t, i18n } = useTranslation();
  const { eventCode } = usePromoCode();

  const getBadgeText = (): string | null => {
    const code = eventCode || 'WEBSITE';
    const promoKey = `promo.${code}.name`;
    // @ts-ignore
    const translation = t(promoKey) as string;

    // If translation doesn't exist (returns the key itself), return discount text
    if (translation === promoKey) {
      return t('intro.title.line1');
    }

    return translation;
  };

  // Format users count with abbreviation based on language
  const isChinese = i18n.language.indexOf("zh") !== -1;
  const formattedUsers = isChinese
    ? Math.floor(stats.users / 10000) + ' 萬+'
    : Math.floor(stats.users / 1000) + 'k+';

  return (
    <section className="pt-8 md:pt-12 bg-gradient-to-b from-slate-50 to-white md:bg-slate-50 md:bg-none">
      <div className="max-w-7xl mx-auto px-8 md:px-3">
        <div className="font-semibold text-sm md:text-base mb-2 block w-fit mx-auto text-center bg-yellow-300 text-slate-800 rounded-full px-4 py-1">
          {getBadgeText()}
        </div>
        <h2 className="text-3xl md:text-5xl font-semibold text-slate-900 mb-6 leading-snug md:leading-snug text-center">
          <div>{t('intro.title.line2')}</div>
          <div className="text-sky-500">
            {t('intro.title.line3')}
          </div>
        </h2>

        <div className="max-w-xl mx-auto text-left text-slate-600 text-base md:text-lg space-y-6 leading-relaxed md:leading-relaxed">
          <p>
            <span className="">{t('intro.description.line1')}</span>
            <span className="font-semibold text-slate-800">{t('intro.description.line2')}</span>
          </p>
          <p>
            <span className="">{t('intro.description.line3')}</span>
            <span className="font-semibold text-slate-800">{t('intro.description.line4')}</span>
          </p>
          <p>
            <span className="">{t('intro.description.line5', { users: formattedUsers })}</span>
          </p>
        </div>

        {/* <h3 className="text-xl md:text-3xl font-semibold text-slate-900 py-4 md:py-8 leading-relaxed md:leading-snug relative">
          <span className="">{t('intro.quote.line1')}</span>
          <span className="">{t('intro.quote.line2')}</span>
          <span className="">{t('intro.quote.line3')}</span>
        </h3> */}
      </div>
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <img
          src="https://cdn-site.clarymind.com/product-page-app/banners/app-store-event-20250902-horizontal.jpg"
          alt=""
          className="w-full rounded-2xl"
        />
      </div> */}
      <div className="max-w-7xl mx-auto px-0 pt-8 block md:hidden">
        <div className="w-full">
          <img
            src="https://cdn-site.clarymind.com/product-page-app/banners/intro-banner.jpg"
            alt=""
            className="w-full"
          />
        </div>
      </div>

    </section>
  );
};

export default Intro;

